import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoading } from "../slices/holidaySlice";
import * as services from "../services/configBesmartApi";
import { generateRandomString } from "utils/helper";
import { setBestamp } from "../slices/attendanceSlice";
import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";

function useBestamp() {
  const dispatch = useDispatch();
  const { currentCompany, currentEmployee } = useSelector(
    (state) => state.company
  );
  const { bestamp } = useSelector((state) => state.attendance);
  const { t } = useTranslation();
  const toInitialValues = (data = []) => {
    const submenu = data?.[0]?.submenu || [];

    return {
      menucodeBestamp: data?.[0]?.statusFlag === "Y",
      switchgps: submenu.find((m) => m.menuCode === "GPS")?.statusFlag === "Y",
      switchwifi: submenu.find((m) => m.menuCode === "WIFI")?.statusFlag === "Y",
      switchselfie:
        submenu.find((m) => m.menuCode === "SELFIE")?.statusFlag === "Y",
      switchqrcode:
        submenu.find((m) => m.menuCode === "QRCODE")?.statusFlag === "Y",
    };
  };
  const toParams = (values = {}, menuList = []) => {
    const bestampMenu = menuList.find(
      (menu) => menu.menuCode === "BESTAMP"
    );

    return {
      id: bestampMenu?.id || null,
      menuCode: "BESTAMP",
      statusFlag: values.menucodeBestamp ? "Y" : "N",
      index: bestampMenu?.index ?? 0,
      submenu: [
        { menuCode: "GPS", statusFlag: values.switchgps ? "Y" : "N", index: 0 },
        { menuCode: "WIFI", statusFlag: values.switchwifi ? "Y" : "N", index: 1 },
        {
          menuCode: "SELFIE",
          statusFlag: values.switchselfie ? "Y" : "N",
          index: 2,
        },
        {
          menuCode: "QRCODE",
          statusFlag: values.switchqrcode ? "Y" : "N",
          index: 3,
        },
      ],
    };
  };
  const getBestamp = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));

      const response = await services.getBesmartConfig({
        requestId: generateRandomString(),
        configType: "BESTAMP",
        companyId: currentCompany,
        actionId: currentEmployee,
      });

      dispatch(setBestamp(response.data?.content));
    } catch (error) {
      console.error("getBestamp error:", error);
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch]);

  const initialValues = useMemo(() => {
    return toInitialValues(bestamp);
  }, [bestamp]);


  const editConfigBesmart = useCallback(
    (values) => {
      Modal.confirm({
        title: t("dialog.confirmation.header"),
        content: <span>{t("dialog.confirmation.edit_action")}</span>,
        async onOk() {
          try {
            dispatch(setIsLoading(true));

            const menuList = bestamp || [];
            const params = toParams(values, menuList);
            await services.editBesmartConfig({
              requestId: generateRandomString(),
              companyId: currentCompany,
              actionId: currentEmployee,
              menuList: params,
            });

            message.success(t("common.successsfull"));
            getBestamp();
          } catch (error) {
            console.error("editConfigBesmart error:", error);
          } finally {
            dispatch(setIsLoading(false));
          }
        },
      });
    },
    [bestamp, currentCompany, currentEmployee, dispatch, getBestamp, t]
  );
  useEffect(() => {
    getBestamp();
  }, [getBestamp]);

  return {
    getBestamp,
    bestamp,
    initialValues,
    editConfigBesmart,
  };
}

export default useBestamp;
